/* eslint-disable react-hooks/exhaustive-deps */
import Accordion from 'SpendController/Components/Accordian/Accordian';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	Header,
	HeaderSpan,
	InnerContainer,
	RefreshSpan,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import {
	GL_HEADER,
	GL_REFRESH_HEADER,
	extractSelectedArrays,
	SAVINGS_SIGNS_OFF_KPI_DATA,
	PENDING_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE,
	LOST_SAVINGS_KPI_DATA,
	updateSavingsData,
	keyMapping,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import { getSavingSignOffSummaryKpis } from 'utils/apiRequests';

function SavingsSignOff() {
	const [savingsSignoffKpiData, setSavingsSignoffKpiData] = useState(
		SAVINGS_SIGNS_OFF_KPI_DATA
	);
	const [isLoading, setIsLoading] = useState(false);
	const selectedSpendType = ['MACRO'];
	const {
		filters,
		savingsSignOffColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		uploadRefresh,
		handleSpendControllerFilters,
		setSpendType,
	} = useSpendControllerFiltersContext();
	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[filters]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			uploadRefresh &&
				(() => {
					handleSpendControllerFilters();
					handleKpiData(filters);
				})();
		},
		[uploadRefresh]
	);
	useEffect(() => {
		setSpendType(selectedSpendType);
	}, []);
	const handleKpiData = async (filters, realTime = false) => {
		const tempFilters = extractSelectedArrays(filters);
		const microFilters = Object.assign({}, tempFilters);
		microFilters.tailSpendType = ['MACRO'];
		realTime && setIsLoading(true);
		const savingsSignoffKpiDataResponse = await getSavingSignOffSummaryKpis(
			microFilters
		);
		const tempPreWorkShopBaselineKpiData = updateSavingsData(
			savingsSignoffKpiDataResponse,
			savingsSignoffKpiData.data,
			keyMapping
		);
		setSavingsSignoffKpiData({
			...savingsSignoffKpiData,
			data: tempPreWorkShopBaselineKpiData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />
			<BreakDownFilters />

			<InnerContainer>
				<Accordion name={`Savings Sign Off Health Bar`} idkey={'acc1'}>
					<InnerContainer>
						<Summary
							{...savingsSignoffKpiData}
							data={[
								savingsSignoffKpiData.data[0],
								savingsSignoffKpiData.data[1],
							]}
						/>
						<Summary
							{...savingsSignoffKpiData}
							data={[
								savingsSignoffKpiData.data[2],
								savingsSignoffKpiData.data[3],
							]}
							title={PENDING_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE}
							Fcolor={`#a4a4a6`}
						/>
						<Summary
							{...LOST_SAVINGS_KPI_DATA}
							data={[
								savingsSignoffKpiData.data[4],
								savingsSignoffKpiData.data[5],
							]}
						/>
					</InnerContainer>
				</Accordion>
			</InnerContainer>
			<ColumnContainer>
				<Header>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableWrapper n={7}>
					<TableView
						data={savingsSignOffColumnDefs}
						columnDefs={savingsSignOffColumnDefs.headers}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						selectedSpendType={selectedSpendType}
					/>
				</TableWrapper>
			</ColumnContainer>
		</Container>
	);
}

export default SavingsSignOff;
